import styled from "styled-components";

export const IndicatorContainer = styled.span`
    padding: 2px 9px;
    border-radius: 8px;
    background: #F5EDFF;
    color: #8540DD;
`